var React = require('react');

function BusinessCardBack (props) {
    return React.createElement("svg",props,React.createElement("rect",{"width":"129.399","height":"86.099"}));
}

BusinessCardBack.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"129.399px","height":"86.099px","viewBox":"0 0 129.399 86.099","enableBackground":"new 0 0 129.399 86.099","xmlSpace":"preserve"};

module.exports = BusinessCardBack;

BusinessCardBack.default = BusinessCardBack;
